import {
  Login,
  Group,
  Workspaces,
  Dashboard,
  Straighten,
  HomeRepairService,
  ConnectWithoutContact,
  AttachMoney,
  CurrencyExchange,
  CallMade,
  CallReceived,
  KeyboardBackspace,
  Assessment,
  Settings,
  Receipt,
} from "@mui/icons-material";
import Signin from "./authentication/sign-in/index";
import Users from "./Pages/admin/users";
import Deskboard from "./Pages/deskboard";
import Submission from "./Pages/submission";
import Result from "./Pages/Result";
import Replied from "./Pages/replied";
import Labout from "./Pages/Labout";
import Bill from "./Pages/Bill";
import CreditNote from "./Pages/CreditNote";
import Parties from "./Pages/Masters/parties";
import Sizes from "./Pages/Masters/sizes";
import Services from "./Pages/Masters/services";
import PriceList from "./Pages/Masters/pricelist";
import Conversionrate from "./Pages/Masters/coversationrate";
import Report from "./Pages/reports";
import AiAgent from "./Pages/AiAgent";
import secureLocalStorage from "react-secure-storage";
export default function useRoutes() {
  const user = secureLocalStorage.getItem("userdata");
  const divider = {
    type: "divider",
    name: "divider",
    key: Math.random() * 10,
  };
  const sign_in = {
    type: "collapse",
    name: "Sign In",
    key: "sign-in",
    icon: <Login />,
    route: "/sign-in",
    component: <Signin />,
  };
  const dashboard = {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Dashboard />,
    route: "/dashboard",
    component: <Deskboard />,
    subItems: false,
    visible: true,
  };
  const admin = [
    {
      type: "collapse",
      name: "Admin",
      key: "/admin",
      icon: <Workspaces />,
      route: "/admin",
      subItems: true,
      visible: true,
      items: [
        {
          type: "collapse",
          name: "Users",
          key: "/admin/users",
          icon: <Group />,
          route: "/admin/users",
          component: <Users />,
          subItems: false,
          visible: true,
        },
      ],
    },
    { ...divider, key: "divider1" },
  ];
  const masters = {
    type: "collapse",
    name: "Masters",
    key: "/masters",
    route: "/masters",
    icon: <Settings />,
    subItems: true,
    visible: true,
  };
  const sizes = {
    type: "collapse",
    name: "Sizes",
    key: "/masters/sizes",
    icon: <Straighten />,
    route: "/masters/sizes",
    component: <Sizes />,
    subItems: false,
    visible: true,
  };
  const services = {
    type: "collapse",
    name: "Services",
    key: "/masters/services",
    icon: <HomeRepairService />,
    route: "/masters/services",
    component: <Services />,
    subItems: false,
    visible: true,
  };
  const parties = {
    type: "collapse",
    name: "Parties",
    key: "/masters/parties",
    icon: <ConnectWithoutContact />,
    route: "/masters/parties",
    component: <Parties />,
    subItems: false,
    visible: true,
  };
  const priceList = {
    type: "collapse",
    name: "Price list",
    key: "/masters/price_list",
    icon: <AttachMoney />,
    route: "/masters/price_list",
    component: <PriceList />,
    subItems: false,
    visible: true,
  };
  const cnv_rate = {
    type: "collapse",
    name: "Conversion Rate",
    key: "/masters/conversion_rate",
    icon: <CurrencyExchange />,
    route: "/masters/conversion_rate",
    component: <Conversionrate />,
    subItems: false,
    visible: true,
  };
  const submission = {
    type: "collapse",
    name: "Submission",
    key: "submission",
    icon: <CallMade />,
    route: "/submission",
    component: <Submission />,
    subItems: false,
    visible: true,
  };
  const result = {
    type: "collapse",
    name: "Results",
    key: "results",
    icon: <CallReceived />,
    route: "/results",
    component: <Result />,
    subItems: false,
    visible: true,
  };
  const replies = {
    type: "collapse",
    name: "Replied",
    key: "replied",
    icon: <KeyboardBackspace />,
    route: "/replied",
    component: <Replied />,
    subItems: false,
    visible: true,
  };
  const returned = {
    type: "collapse",
    name: "Lab Out",
    key: "labout",
    icon: <KeyboardBackspace sx={{ rotate: "180deg" }} />,
    route: "/labout",
    component: <Labout />,
    subItems: false,
    visible: true,
  };
  const billing = {
    type: "collapse",
    name: "Billing",
    key: "bill",
    icon: <Receipt />,
    route: "/bill",
    component: <Bill />,
    subItems: false,
    visible: true,
  };
  const creditnote = {
    type: "collapse",
    name: "Credit Notes",
    key: "creditnote",
    route: "/creditnote",
    icon: <Receipt />,
    component: <CreditNote />,
    subItems: false,
    visible: true,
  };
  const report = {
    type: "collapse",
    name: "Report",
    key: "report",
    icon: <Assessment />,
    route: "/report",
    component: <Report />,
    subItems: false,
    visible: true,
  };
  const ai_agent = {
    type: "collapse",
    name: "AI Agent",
    key: "ai_agent",
    icon: <Assessment />,
    route: "/ai_agent",
    component: <AiAgent />,
    subItems: false,
    visible: false,
  };
  const apppermissionsRoutes = [dashboard, { ...divider, key: "divider2" }, ai_agent];
  if (!user) {
    return [sign_in];
  } else {
    // only admin and which is has permission
    (user?.u_type === 1 || user?.p_user) && apppermissionsRoutes.push(...admin);
    const masters_routes = [];
    if (user?.p_size) {
      masters_routes?.push(sizes);
    }
    if (user?.p_service) {
      masters_routes?.push(services);
    }
    if (user?.p_party) {
      masters_routes?.push(parties);
    }
    if (user?.p_pl) {
      masters_routes?.push(priceList);
    }
    if (user?.p_conv_rate) {
      masters_routes?.push(cnv_rate);
    }
    if (masters_routes?.length > 0) {
      apppermissionsRoutes?.push({ ...masters, items: masters_routes });
    }
    if (user?.p_submit) {
      apppermissionsRoutes?.push(submission);
    }
    if (user?.p_results) {
      apppermissionsRoutes?.push(result);
    }
    if (user?.p_replies) {
      apppermissionsRoutes?.push(replies);
    }
    if (user?.p_returns) {
      apppermissionsRoutes?.push(returned);
    }
    if (user?.p_billing) {
      apppermissionsRoutes?.push(billing);
    }
    apppermissionsRoutes?.push(creditnote);
    if (user?.p_reports) {
      apppermissionsRoutes?.push(report);
    }
    return apppermissionsRoutes;
  }
}
